/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoadFactor {
    LOW_LOAD = 'LOW_LOAD',
    WELL_LOADED = 'WELL_LOADED',
    OVERLOADED = 'OVERLOADED',
}
